export const cleanup = (obj) => {
  let newObj =  {}
  for (const p of Object.getOwnPropertyNames(obj)) {
    switch (p) {
      case 'id':
      case 'rating':
      case 'lvl':
        newObj[p] = parseInt(obj[p]);
        break;
      case 'premium':
        newObj[p] = !!parseInt(obj[p]);
        break;
      case 'table': {
        const v = parseInt(obj[p]);
        newObj[p] = v === -1 ? null : v;
        break;
      }
      case 'local': {
        newObj[p] = obj[p] === 'TRUE';
        break;
      }
      default:
        newObj[p] = obj[p];
    }
  }
  return newObj;
};